/**
 * Reporta `client_onboarding_profiles.last_seen_at` cada vez que el
 * usuario abre la app — sea browser o PWA instalada. Distinto a
 * `useStandaloneTracker` (que SOLO marca cuando es PWA standalone).
 *
 * Sirve para que el admin/coach puedan ver "última conexión" como
 * señal complementaria a "última actividad". El par responde:
 *   - Cliente que entra pero no registra → problema de producto/UX
 *   - Cliente que ni entra → abandono
 *
 * Throttle de 1h para no spamear la BD en cada navegación. El cliente
 * típico abre la app varias veces al día; con 1h capturamos las
 * "sesiones" reales sin lavar la BD.
 */

import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const LAST_REPORT_KEY = 'iftmx:last_seen_report';
const REPORT_THROTTLE_MS = 60 * 60 * 1000; // 1h

export function useLastSeenTracker(userId: string | null | undefined) {
  useEffect(() => {
    if (!userId) return;

    // Throttle: si reportamos hace <1h, salir.
    const last = parseInt(localStorage.getItem(LAST_REPORT_KEY) || '0', 10);
    if (Date.now() - last < REPORT_THROTTLE_MS) return;

    // Usamos el RPC SECURITY DEFINER para evitar problemas de RLS y
    // para que la lógica viva server-side (más fácil de cambiar).
    supabase
      .rpc('touch_my_last_seen')
      .then(({ error }) => {
        if (!error) {
          localStorage.setItem(LAST_REPORT_KEY, String(Date.now()));
        }
      });
  }, [userId]);
}
